import React from 'react';

import {
  parseISO,
  formatDistance, isAfter,
} from 'date-fns';

import { ptBR } from 'date-fns/locale';

import { MdVisibility, MdLiveTv, MdSchedule } from "react-icons/md";
import { FaCrown, FaPlay } from "react-icons/fa";

import personagem from '../img/person.png'

import { global } from '../api/global'
///(item.online) ? `https://live.judah.tv/screenshot/live/${item._id}.jpg?random_number=${Math.random()}` : 
//     <img className="lifoto  " src={(item.online) ? `https://live.soundclub.live/screenshot/live/${item._id}.jpg?random_number=${Math.random()}` : `${global.brl.REACT_APP_FOTO}${item.fotoid}.jpg`} onError={(e) => { e.target.onerror = null; e.target.src = personagem }} alt="foto" />

function PgLivesItem({ item }) {
  const getBackgroundImage = () => {
    if (item.online) {
      return `https://live.soundclub.live/screenshot/live/${item._id}.jpg?random_number=${Math.random()}`;
    } else {
      return item.fototv === '' 
        ? `${global.brl.REACT_APP_FOTO}${item.fotoid}.jpg` 
        : `${global.brl.REACT_APP_FOTO}${item.fototv}.jpg`;
    }
  };

  const getStatusInfo = () => {
    if (item.online) {
      return {
        status: item.paga ? 'Premium' : 'Free Live',
        color: item.paga ? 'text-secondary-light' : 'text-primary-light',
        bgColor: item.paga ? 'bg-secondary/20' : 'bg-primary/20',
        icon: item.paga ? FaCrown : FaPlay
      };
    } else {
      if (item.linkplay !== '') {
        return {
          status: 'On Demand',
          color: 'text-blue-400',
          bgColor: 'bg-blue-500/20',
          icon: FaPlay
        };
      } else if (item.mostrar && item.linkultimo !== '') {
        return {
          status: 'Última Live',
          color: 'text-purple-400',
          bgColor: 'bg-purple-500/20',
          icon: MdSchedule
        };
      } else {
        return {
          status: 'Offline',
          color: 'text-text-subtle',
          bgColor: 'bg-surface',
          icon: MdSchedule
        };
      }
    }
  };

  const statusInfo = getStatusInfo();
  const StatusIcon = statusInfo.icon;

  return (
    <div className="group relative bg-surface border border-border rounded-2xl overflow-hidden 
                   transition-all duration-300 ease-out
                   hover:-translate-y-1 hover:shadow-glow hover:border-primary/50">
      
      <div className="relative aspect-video overflow-hidden">
        {/* Background Image with Hover Effect */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-105"
          style={{
            backgroundImage: `url(${getBackgroundImage()})`,
            imageRendering: 'crisp-edges', // For potentially pixelated stream images
          }}
          onError={(e) => {
            // Fallback to default person image
            e.target.style.backgroundImage = `url(${personagem})`;
          }}
        />
        
        {/* Play Icon Overlay on Hover 
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center
                        opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <FaPlay className="text-white text-4xl" />
        </div>*/}

        {/* Gradient Overlay for Text Readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent" />
        
        {/* Live Indicator */}
        {item.online && (
          <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 bg-red-600 text-white text-xs font-bold rounded-full shadow-lg">
            <div className="w-2 h-2 bg-white rounded-full animate-pulse" />
            <span>LIVE</span>
          </div>
        )}
        
        {/* Viewer Count */}
        {item.online && item.nrviwers > 0 && (
          <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2.5 py-1 bg-black/60 backdrop-blur-md text-white text-xs rounded-full">
            <MdVisibility className="text-base" />
            <span>{item.nrviwers}</span>
          </div>
        )}
      </div>

      {/* Content Area */}
      <div className="p-4 space-y-3">
        <h3 className="font-display text-lg font-bold text-text truncate transition-colors duration-300 group-hover:text-primary-light">
          {item.username}
        </h3>

        {/* Status Row */}
        <div className="flex items-center justify-between text-xs">
          {/* Status Badge */}
          <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full font-semibold ${statusInfo.bgColor} ${statusInfo.color}`}>
            <StatusIcon />
            <span>{statusInfo.status}</span>
          </div>

          {/* Next Live Time */}
          {!item.online && item.proximalive && isAfter(parseISO(item.proximalive), new Date()) && (
            <div className="text-text-subtle">
              <span>em </span>
              {formatDistance(parseISO(item.proximalive), new Date(), { 
                locale: ptBR, 
                addSuffix: false, 
                includeSeconds: false 
              }).replace("cerca de ", "")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PgLivesItem;